import { useSelector } from 'react-redux';

import { StoreState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { AppState, NavigationState } from '../..';

export const useNavigationStore = (): NavigationState => {
	return useSelector((state: StoreState<AppState>) => state.appState.navigationState);
};
